<template>
    <div class="list-raovat list-raovat-epxired">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Danh sách sản phẩm không được duyệt
        </div>
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" class="text-center">
                        STT
                    </th>
                    <th scope="col" class="text-center">Ảnh</th>
                    <th scope="col">Tiều đề</th>
                    <th scope="col">Giá</th>
                    <th scope="col" class="text-center">Thao tác</th>
                </tr>
            </thead>
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                        
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <tbody v-if="proExpired.length == 0">
                <tr>
                    <td colspan="6" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>
            <tbody v-else-if="$detect == 'web'">
                <tr class="position-relative" v-for="(item,index) in proExpired" :key="index">
                    <td scope="row" style="white-space: nowrap;">
                       {{index+1}}
                    </td>
                    <td width="50" class="position-relative">
                        <img class="img-web" :src="item.image" onerror="errorImage(this)"/>
                    </td>
                    <td class="name-rv">
                        <div>
                            <a class="text-decoration-none" :href="$linkUrl(item.link)" target="_blank">
                                <span class="pr-2 id-table">#{{ item.id }}</span><span class="name-item">{{ item.name }}</span>
                            </a>
                        </div>
                    </td>
                    <td width="100" class="position-relative">
                        <p class="mb-0 text-danger fw-600" v-html="item.price"></p>
                    </td>
                    <td width="200" class="text-center">
                        <button type="button" class="btn btn-primary btn-sm px-3 mr-2"
                            @click="edit(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                            <i class="icon ion-md-create"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destrory(item, index)" :disabled="index === loading && loadingAction == 'destrory'">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="table-mobile" v-for="(item, index) in proExpired" :key="index">
                    <td class="img-tab position-relative pl-1">
                        <div class="checkbox-mobile position-absolute">
                            
                        </div>
                        <div>
                            <img :src="item.image" onerror="errorImage(this)" @click="pushIdMuti(item)"/>
                        </div>
                    </td>
                    <td>
                        <div class="name">
                            <a class="text-decoration-none" :href="item.link" target="_blank">
                                <span class="name-item">{{ item.name }}</span>
                            </a>
                        </div>
                        <div class="d-flex justify-content-between mt-2">
                            <div class="price-tab" v-html="item.price"></div>
                        </div>
                        <div class="mt-2">
                            <button type="button"
                                class="btn btn-primary btn-sm mr-2 w-btn"
                                @click="availability(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                Sửa
                            </button>
                            <button type="button" class="btn btn-danger btn-sm ml-2 w-btn"
                                @click="destrory(item, index)" :disabled="index === loading && loadingAction == 'destrory'">
                                Xoá
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getExpired"/>
    </div>
</template>

<script>
import { availability, destroy } from '@/config/product';
export default {
    components: {
        fillterExp: () => import('./fillter.vue'),
        paginate: () => import('@/components/layout/pagination.vue'),
    },
    data() {
        return {
            proExpired: [],
            idSelect: [],
            last_page: 0,
            next_page: 0,
            current_page: 0,
            data_fillter: {
                category: 0,
                expire: 1,
                keyword: '',
            },
            selectAll: false,
            loading: '',
            loadingAction: '',
        }
    },
    created() {
        this.getExpired(1);
        this.$eventBus.$on('call-page-expire', () => {
            this.idSelect = [];
            this.getDataAction(this.current_page);
        });
    },
    methods: {
        getExpired(page) {
            let params = {
                page: page
            };
            this.idSelect = [];
            this.selectAll = false;
            apiGet('v2/profile/products/expired', params).then(res => {
                this.proExpired = res.data.data;
                this.last_page = res.data.last_page;
                this.next_page = res.data.next_page;
                this.current_page = res.data.current_page;
                this.selectAll = false;
            })
        },
        async availability(item, index = null){
            this.loading = index;
            this.loadingAction = 'availability';
            await availability([item.id], this);
            this.loading = '';
            this.loadingAction = '';
            await this.getDataAction(this.current_page);
        },
        async destrory(item, index = null){
            this.loading = index;
            this.loadingAction = 'destrory';
            await destroy(item.id, this)
            this.loading = '';
            this.loadingAction = '';
            await this.getDataAction(this.current_page);
        },
        edit(item, index){
            this.loading = index;
            if(item.pro_exclusive == 1){
                this.$router.push({
                    name: 'product-edit',
                    params: {id: item.id}
                })
            }else{
                this.$router.push({
                    name: 'product-update',
                    params: {id: item.id}
                })
            }
        },
        async getDataAction(page){
            if(page < 1) return;
            let params = {
                page: page,
            };
            this.idSelect = [];
            this.selectAll = false;
            let data = {};
            await apiGet('v2/profile/products/expired', params).then(res => {
                if(res.data.current_page == 1){
                    this.proExpired = res.data.data;
                    this.last_page = res.data.last_page;
                    this.next_page = res.data.next_page;
                    this.current_page = res.data.current_page;
                }
                data = res.data;
            });
            if(data.data.length == 0){
                this.getDataAction(page - 1);
            }else{
                this.proExpired = data.data;
                this.last_page = data.last_page;
                this.next_page = data.next_page;
                this.current_page = data.current_page;
            }
        }
    },
    watch: {
        data_fillter: {
            handler(val){
                this.getExpired(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.proExpired.map(item => {
                    this.idSelect.push(item.id);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.proExpired.map(item => {
                    count += 1;
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
    }
}
</script>

<style lang="scss">
    .table-mobile {
        .w-btn {
            width: calc( 50% - 8px );
        }
        .checkbox-mobile {
            top: 19px !important;
            left: 7px !important;
        }
    }
</style>
